export enum ConversionWorkflowStatus {
  Pending = 17,
  Submitted = 18,
  Voided = 19,
}

export const CONVERSION_WORKFLOW_STATUS_OPTIONS: ReadonlyArray<{
  id: ConversionWorkflowStatus;
  name: string;
  color: string;
}> = [
  { id: ConversionWorkflowStatus.Pending, name: "Pending", color: "warning" },
  { id: ConversionWorkflowStatus.Submitted, name: "Submitted", color: "success" },
  { id: ConversionWorkflowStatus.Voided, name: "Voided", color: "medium" },
];
